/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */

((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const mainMovie = () => {
		const stopBtn = document.querySelector('.js-stopBtn');
		const videos = document.querySelectorAll('.sme-main .__movie video');
		const stopIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#stop_circle"></use></svg>';
		const playIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#play_circle"></use></svg>';

		let isPlaying = true; // 初期状態は autoplay なので再生中扱い

		stopBtn.addEventListener('click', () => {
			videos.forEach(video => {
				// 現在表示されている video のみ制御（display:none 対策）
				const style = window.getComputedStyle(video);
				if (style.display === 'none') return;
				if (isPlaying) {
					video.pause();
					stopBtn.querySelector('.__txt').textContent = 'Play';
					stopBtn.querySelector('svg').outerHTML = playIcon;
				} else {
					video.play();
					stopBtn.querySelector('.__txt').textContent = 'Stop';
					stopBtn.querySelector('svg').outerHTML = stopIcon;
				}
			});
			isPlaying = !isPlaying;
		});
	};

	// ================================================================
	mainMovie();

})(window.FUNCTIONS);
